import { useState, useEffect, useCallback } from 'react';

const MOTIVATIONAL_MESSAGES = [
  { id: 1, message: "Believe in yourself — you are stronger than you think." },
  { id: 2, message: "Every day is a new chance to shine brighter than yesterday." },
  { id: 3, message: "Success begins with a positive mindset and relentless action." },
  { id: 4, message: "Keep pushing forward — your effort always matters." },
  { id: 5, message: "Challenges are opportunities in disguise. Embrace them." },
  { id: 6, message: "Stay focused. Greatness takes time, but it always comes." },
  { id: 7, message: "Consistency beats talent when talent doesn't work hard." },
  { id: 8, message: "Your hard work today builds tomorrow\'s success." },
  { id: 9, message: "Never stop learning — growth is endless and beautiful." },
  { id: 10, message: "Small steps taken daily lead to extraordinary achievements." },
  { id: 11, message: "Dream big, work hard, stay humble, and never give up." },
  { id: 12, message: "Keep believing — success is inevitable for those who persist." },
  { id: 13, message: "Your attitude determines your direction. Choose positivity." },
  { id: 14, message: "The best time to start was yesterday. The next best time is now." },
  { id: 15, message: "You are capable of amazing things — trust the process." },
  { id: 16, message: "Every expert was once a beginner. Keep going." },
  { id: 17, message: "Progress, not perfection, is the goal. Move forward." },
  { id: 18, message: "Your potential is limitless — don't let doubt define you." },
  { id: 19, message: "Hard work is the bridge between goals and achievement." },
  { id: 20, message: "Rise up, show up, and never give up on your dreams." },
  { id: 21, message: "The only limit is the one you set in your own mind." },
  { id: 22, message: "Invest in yourself — it pays the best interest." },
  { id: 23, message: "Discipline is choosing what you want most over what you want now." },
  { id: 24, message: "Your work ethic speaks louder than any words ever could." },
  { id: 25, message: "Be the energy you want to attract in your workplace." },
  { id: 26, message: "One step at a time is still moving forward. Keep going." },
  { id: 27, message: "Success is not final, failure is not fatal — it's the courage to continue." },
  { id: 28, message: "You don't have to be great to start, but you have to start to be great." },
  { id: 29, message: "Strive for progress every single day, no matter how small." },
  { id: 30, message: "Your dedication today is your competitive advantage tomorrow." },
  { id: 31, message: "Great things never come from comfort zones. Push your limits." },
  { id: 32, message: "The harder you work, the luckier you seem to get." },
  { id: 33, message: "Believe in your vision even when others can\'t see it yet." },
  { id: 34, message: "Every challenge you overcome makes you stronger and wiser." },
  { id: 35, message: "Your mindset is your most powerful tool — sharpen it daily." },
  { id: 36, message: "Success is the sum of small efforts repeated day in and day out." },
  { id: 37, message: "Don't watch the clock — do what it does. Keep moving." },
  { id: 38, message: "The secret of getting ahead is getting started. Begin now." },
  { id: 39, message: "You are one decision away from a completely different life." },
  { id: 40, message: "Talent is given, but greatness is earned through effort." },
  { id: 41, message: "Stay patient and trust your journey — everything unfolds in time." },
  { id: 42, message: "Your best work is ahead of you. Keep showing up." },
  { id: 43, message: "Courage is not the absence of fear — it\'s acting despite it." },
  { id: 44, message: "Make today so productive that yesterday becomes jealous." },
  { id: 45, message: "Excellence is not a destination — it\'s a continuous journey." },
  { id: 46, message: "The difference between ordinary and extraordinary is that little extra." },
  { id: 47, message: "Work hard in silence. Let your results make the noise." },
  { id: 48, message: "Every morning brings new potential. Seize it with both hands." },
  { id: 49, message: "You are building something great — one day at a time." },
  { id: 50, message: "Persistence is the key that unlocks every locked door." },
  { id: 51, message: "Your effort today is an investment in your future self." },
  { id: 52, message: "Don\'t count the days — make the days count." },
  { id: 53, message: "The strongest people are not those who show strength, but those who persist." },
  { id: 54, message: "Motivation gets you started. Habit keeps you going." },
  { id: 55, message: "You have the power to create the career you deserve." },
  { id: 56, message: "Every problem is a gift — without them, we wouldn't grow." },
  { id: 57, message: "Be so good they can\'t ignore you. Keep honing your craft." },
  { id: 58, message: "Your future is created by what you do today, not tomorrow." },
  { id: 59, message: "Embrace the grind — it\'s shaping you into who you\'re meant to be." },
  { id: 60, message: "Success is not about being the best — it\'s about always improving." },
  { id: 61, message: "The only way to do great work is to love what you do." },
  { id: 62, message: "Resilience is knowing that you are the only one who can pick yourself up." },
  { id: 63, message: "Your contribution matters more than you know. Keep giving your best." },
  { id: 64, message: "Focus on the step in front of you, not the whole staircase." },
  { id: 65, message: "A positive attitude can turn a storm into a sprinkle." },
  { id: 66, message: "You are closer to your goal than you were yesterday." },
  { id: 67, message: "The road to success is always under construction — keep building." },
  { id: 68, message: "Believe you can and you\'re halfway there." },
  { id: 69, message: "Your energy is contagious — make it worth catching." },
  { id: 70, message: "Don't stop when you're tired. Stop when you're done." },
  { id: 71, message: "Every day you show up is a victory worth celebrating." },
  { id: 72, message: "Surround yourself with those who lift you higher." },
  { id: 73, message: "The pain of discipline is far less than the pain of regret." },
  { id: 74, message: "You are not defined by your past — you are shaped by your choices." },
  { id: 75, message: "Commit to excellence and the results will follow." },
  { id: 76, message: "Your ideas have value — speak up and make them heard." },
  { id: 77, message: "Teamwork makes the dream work. Collaborate and conquer." },
  { id: 78, message: "Be the change you wish to see in your organization." },
  { id: 79, message: "Integrity is doing the right thing even when no one is watching." },
  { id: 80, message: "Your reputation is built one action at a time. Make it count." },
  { id: 81, message: "Innovation starts with curiosity. Never stop asking why." },
  { id: 82, message: "The best investment you can make is in your own skills." },
  { id: 83, message: "Gratitude turns what we have into enough. Be thankful today." },
  { id: 84, message: "Lead by example — your actions inspire more than your words." },
  { id: 85, message: "Every setback is a setup for a greater comeback." },
  { id: 86, message: "Your passion is your superpower — let it drive you forward." },
  { id: 87, message: "Quality work speaks for itself. Deliver excellence always." },
  { id: 88, message: "The greatest glory is not in never falling, but in rising every time." },
  { id: 89, message: "Be proud of how far you\'ve come and excited for what\'s ahead." },
  { id: 90, message: "Your character is your most valuable professional asset." },
  { id: 91, message: "Take ownership of your growth — no one else will do it for you." },
  { id: 92, message: "Clarity of purpose turns ordinary effort into extraordinary results." },
  { id: 93, message: "The world needs your unique talents — don't hold back." },
  { id: 94, message: "Adaptability is the most important skill in a changing world." },
  { id: 95, message: "Your network is your net worth — invest in meaningful relationships." },
  { id: 96, message: "Patience and persistence together are an unstoppable force." },
  { id: 97, message: "Do more than is expected and you will always stand out." },
  { id: 98, message: "A goal without a plan is just a wish. Plan, then execute." },
  { id: 99, message: "You are exactly where you need to be — keep growing from here." },
  { id: 100, message: "Today is a gift. Unwrap it with enthusiasm and make it count." },
];

const STORAGE_KEY = 'motivational_popup';
const BANNER_KEY = 'motivational_banner_active';
const SESSION_SHOWN_KEY = 'motivational_popup_shown_this_session';

/**
 * Picks a daily motivational message that:
 * - Changes once per calendar day (date-seeded, deterministic)
 * - Does not repeat consecutively (avoids last shown message)
 * - Shows popup ONCE per login session (session gate via sessionStorage)
 * - Popup stays visible until user manually dismisses it (no auto-disappear)
 * - Dismissed messages remain visible as a persistent dashboard banner
 */
const useMotivationalMessage = (userId) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [message, setMessage] = useState(null);

  const getTodayKey = () => new Date()?.toISOString()?.slice(0, 10); // YYYY-MM-DD

  const getDailyMessage = useCallback(() => {
    const today = getTodayKey();
    const stored = (() => {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch { return {}; }
    })();

    // If we already have today's message, use it
    if (stored?.date === today && stored?.messageId) {
      return MOTIVATIONAL_MESSAGES?.find(m => m?.id === stored?.messageId) || MOTIVATIONAL_MESSAGES?.[0];
    }

    // Pick a new message for today — avoid repeating the last one
    const lastId = stored?.messageId || null;
    const candidates = MOTIVATIONAL_MESSAGES?.filter(m => m?.id !== lastId);

    // Use today's date string as a deterministic seed so all users see the same daily message
    const seed = today?.replace(/-/g, '');
    const index = parseInt(seed, 10) % candidates?.length;
    const selected = candidates?.[index];

    // Persist for today
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ date: today, messageId: selected?.id }));
    return selected;
  }, []);

  useEffect(() => {
    if (!userId) return;

    const msg = getDailyMessage();
    setMessage(msg);

    // Restore banner state from localStorage (persists across sessions)
    const bannerActive = localStorage.getItem(BANNER_KEY);
    if (bannerActive === 'true') {
      setShowBanner(true);
    }

    // Show popup only ONCE per login session — session gate via sessionStorage
    const alreadyShownThisSession = sessionStorage.getItem(SESSION_SHOWN_KEY);
    if (alreadyShownThisSession) return;

    // Small delay to let the login notification popup settle first
    const timer = setTimeout(() => {
      setShowPopup(true);
      sessionStorage.setItem(SESSION_SHOWN_KEY, 'true');
    }, 2500);

    return () => clearTimeout(timer);
  }, [userId, getDailyMessage]);

  // User clicks X or "Continue" on popup — move to persistent banner
  const handleDismiss = useCallback(() => {
    setShowPopup(false);
    setShowBanner(true);
    localStorage.setItem(BANNER_KEY, 'true');
  }, []);

  // User explicitly closes the banner
  const handleCloseBanner = useCallback(() => {
    setShowBanner(false);
    localStorage.removeItem(BANNER_KEY);
  }, []);

  return {
    showPopup,
    showBanner,
    message,
    handleDismiss,
    handleCloseBanner,
  };
};

export default useMotivationalMessage;
